import { Observable } from 'rxjs';
import { DocumentSearch } from './../../shared/models/document.search';
import { EntityOtherService } from './../other/entity-other.service';
import { EntityDetailsService } from './../details/entity-details.service';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, Input, OnInit, OnChanges, ViewContainerRef } from '@angular/core';

import { Document } from 'app/shared/models/document.model';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { AddDocumentComponent } from 'app/shared/components/adddocument/add-document.component';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';

@Component({
  templateUrl: './entity-documents.component.html'
})

export class EntityDocumentsComponent implements OnInit, OnChanges {
  @Input()
  entityIdDetails: EntityIdDetails;
  documents: Document[];
  public entityId: number;
  selectedLabel: number;
  selectedDocumentType: number;
  labels = [];
  isDocumentLoaded = false;
  searchString: string;
  showSearch: boolean;
  isSearchBycontent: boolean;
  documentTypes: ApplicationValue[];

  dialogRef: MdDialogRef<any>;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    public entityDetailsService: EntityDetailsService,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
    public entityDocumentsService: EntityDocumentsService
  ) {}

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.updateDocuments();
    } else {
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
          this.updateDocuments();
        }
      );
    }

    this.entityDocumentsService.updatedDoucment.subscribe(result => {
      if (result.action === 'delete') {
        this.deleteDocument(result.document);
      } else if (result.action === 'add') {
        this.documents.push.apply(this.documents, result.documents);
      } else if (result.action === 'label') {
        this.updateDocuments();
      } else {
        this.updateDoucment(result.documents);
      }
    });

    this.entityDocumentsService.getDocumentLabels().subscribe(
      response => {
        this.labels = response.arrResult['values'];
      }
    );
    this.loadCategoryTypes(this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE));
  }

  ngOnChanges() {
    this.documents = [];
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.updateDocuments();
    }
  }

  updateDocuments() {
    this.entityId = this.entityIdDetails.entityId;
    this.getDocumentList();
  }

  getDocumentList() {
    console.log('[SELECTED LABEL DOCUMENTS] ', this.selectedLabel);
    this.entityDocumentsService.listDocuments(this.entityId, this.selectedLabel || 0)
      .subscribe(response => {
        this.documents = response.arrResult;
        this.isDocumentLoaded = true;
      }, err => {
        this.callSnackBarService(err, '');
        this.isDocumentLoaded = true;
      }
      );
  }

  deleteDocument(document: Document) {
    this.documents.splice(this.documents.indexOf(document), 1);
  }

  updateDoucment(documents: Array<Document>) {
    documents.forEach(document => {
      for (const index in this.documents) {
        if (this.documents[index].id === document.id) {
          this.documents[index] = document;
        }
      }
    });
  }

  openAddDocumentDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddDocumentComponent, config);
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.componentInstance.action = 'Add';
    this.dialogRef.afterClosed().subscribe(result => {
      if (result && result.flagResult) {
        this.updateDocuments();
      }
    });
  }

  callSnackBarService(response: any, successMsg) {
    this.snackBarService
      .showStatus(response,
      successMsg,
      MessageService.DOCUMENT_FAILURE);
  }

  searchDoc() {

    this.showSearch = false;
    if (this.searchString || this.selectedLabel || this.selectedDocumentType) {
      this.isDocumentLoaded = false;
      const document = new DocumentSearch();
      document.name = this.searchString;
      if (this.isSearchBycontent && this.searchString.length > 0) {
        document.content = this.searchString;
      }
      document.labelId = this.selectedLabel;
      document.entityId = this.entityId;
      document.typeId = this.selectedDocumentType;
      this.entityDocumentsService.searchDocument(document)
        .subscribe(response => {
          this.documents = response.arrResult;
          this.isDocumentLoaded = true;
        }, err => {
          this.callSnackBarService(err, '');
          this.isDocumentLoaded = true;
        }
        );
    } else {
      this.getDocumentList();
    }
  }
  focus() {
    this.showSearch = true;
  }
  closeSearch() {
    this.showSearch = false;
    this.searchString = '';
    this.selectedLabel = 0;
    this.selectedDocumentType = 0;
    this.isSearchBycontent = false;
    this.getDocumentList();
  }

  loadCategoryTypes(documentTypeValues: any) {
    if (documentTypeValues instanceof Observable) {
      documentTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.documentTypes = response.values;

        }
      );
    } else {
      this.documentTypes = documentTypeValues;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/documents/entity-documents.component.ts